import React from 'react'
import { Modal, Icon } from "antd"
import LazyLoad from 'react-lazyload'

const Image = (props) => {
    const { previewImage } = props
    const [visible, setVisible] = React.useState(false)

    const _showModalPreview = () => {
        setVisible(true)
    }

    const _hideModalPreview = () => {
        setVisible(false)
    }

    return (
        previewImage &&
        <div className='Preview position-relative'>
            <img src={previewImage} className='position-absolute' alt='preview' />

            <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                <span className='Icon cursor-pointer mr-2' onClick={() => _showModalPreview()}>
                    <Icon type='eye' />
                </span>
            </div>

            <Modal visible={visible} closable={false} centered={true} footer={null} width={1200}
                onCancel={() => _hideModalPreview()} className='PrintedFileModal mw-1200'>
                <div className="Previewer">
                    <LazyLoad>
                        <img src={previewImage} alt='preview' className='d-block m-auto' />
                    </LazyLoad>
                </div>
            </Modal>
        </div>
    )
}

export default Image